import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { SettingsCard } from './SettingsCard';
import { FormItem, SelectField } from 'componets/form';

import { Rules } from 'utils/constants';
import { language } from 'utils/i18n';

import { useAppSelector, useTranslate } from 'hooks';

import s from './index.module.scss';
import classnames from "classnames";

export const SettingsLanguageCard: FC = () => {
	const { languageText } = useTranslate(['languageText']);

	const { t } = useTranslation();

	const languages = useAppSelector((state) => state.settings.globals.languages);

	const languagesOptions = useMemo(
		() =>
			Object.keys(languages).map((item) => {
				return {
					label: t(languages[item]),
					value: item,
				};
			}) || [],
		[languages, t],
	);

	return (
		<SettingsCard title={languageText}>
			<div className={s.contentCol}>
				<FormItem name="language" rules={[Rules.REQUIRED]} className={classnames(s.languageInput, s.inputMaxWith312)}>
					<SelectField options={languagesOptions} placeholder={languageText} value={language} />
				</FormItem>
			</div>
		</SettingsCard>
	);
};
